import * as React from "react";
import { cn } from "@/lib/cn";

export interface ListShellProps extends React.HTMLAttributes<HTMLDivElement> {
  header: React.ReactNode;
  filters?: React.ReactNode;
  pagination?: React.ReactNode;
  children: React.ReactNode;
}

export const ListShell = React.forwardRef<HTMLDivElement, ListShellProps>(
  ({ header, filters, pagination, children, className, ...props }, ref) => (
    <div ref={ref} className={cn("flex flex-col gap-4", className)} {...props}>
      {header}
      {filters && (
        <div className="flex items-center gap-2 flex-wrap">
          {filters}
        </div>
      )}
      <div className="flex flex-col gap-3">{children}</div>
      {pagination && <div className="mt-2">{pagination}</div>}
    </div>
  ),
);
ListShell.displayName = "ListShell";
